import { fetcherReactQuery } from '../../services/api/fetcher'
import { useQuery } from 'react-query'
const fetch = async (api) => {
    const response = await fetcherReactQuery(api)
    return response.data
}
const useNominaType = (empresaconvenioid, ind) => {
    return useQuery([`/api/ObtenerTipoNominaDD/${empresaconvenioid}/${ind}`], fetch)
}
export default useNominaType